"use client";

import { Checkout } from "@up/checkout";

export default function CheckoutPage() {
  return <Checkout />;
}
